export const reloadImg = (src) => {
  // eslint-disable-next-line no-var
  var iframe = window.document.createElement('iframe');

  return new Promise((r) => {
    let firstLoad = true;
    const loadCallback = (e) => {
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(
        '<html><head><title></title></head><body><img src="' +
          src +
          '"></body></html>'
      );
      doc.close();
      if (firstLoad) {
        firstLoad = false;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        iframe.contentWindow.location.reload(true);
      } else {
        if (iframe.parentNode) {
          const img = new Image();
          img.onload = (e) => {
            iframe.parentNode.removeChild(iframe);
          };
          img.src = src;
        }
        r(undefined);
      }
    };
    iframe.setAttribute('src', '/empty.html');
    iframe.style.visibility = 'hidden';
    window.parent.document.body.appendChild(iframe);

    iframe.addEventListener('load', loadCallback, false);
    iframe.addEventListener('error', loadCallback, false);
  });
};
